import React from "react";
import { useNavigate } from "react-router-dom";
import { Result, Button, Card } from "antd";
import { CloseCircleOutlined, HomeOutlined } from "@ant-design/icons";
import { Container } from "./PricingStyle";

export default function SubscriptionCancel() {
  const navigate = useNavigate();

  return (
    <Container>
      <div className="cancel-container">
        <Card className="cancel-card">
          <Result
            icon={<CloseCircleOutlined style={{ color: "#ff4d4f" }} />}
            title="Subscription Cancelled"
            subTitle={
              <div className="cancel-details">
                <p>Your subscription process was cancelled.</p>
                <p>No charges have been made. You can try again anytime.</p>
              </div>
            }
            extra={[
              <Button
                type="primary"
                size="large"
                onClick={() => navigate("/pricing")}
                key="pricing"
              >
                Back to Pricing
              </Button>,
              <Button
                size="large"
                icon={<HomeOutlined />}
                onClick={() => navigate("/")}
                key="home"
              >
                Go to Dashboard
              </Button>,
            ]}
          />
        </Card>
      </div>
    </Container>
  );
}

